import module from 'finanzas/module.js'

export class CargarMovimientosBancariosCsvSantanderService {

  constructor (CargarMovimientosBancarios) {
    this.CargarMovimientosBancariosService = CargarMovimientosBancarios
  }

  obtenerDatos (archivo, obj_CuentaBancaria, session) {
    let resultado = []
    archivo.map((item, index) => {
      let cells = item.replace(/'/g, '').split(',')
      if (index !== 0 && cells.length > 1) {
        cells[1] = cells[1].replace(/\D/g, '')
        resultado.push({
          'cuenta': cells[0].trim(),
          'fecha': new Date(+cells[1].substring(4, 8), +cells[1].substring(2, 4)-1 , +cells[1].substring(0, 2)),
          'hora': cells[2].trim(),
          'sucursal': cells[3].trim(),
          'descripcion': cells[4].trim(),
          'transaccion': cells[4].trim(),
          'notas': cells[4].trim(),
          'cargo': cells[5] === '-' ? cells[6].trim() : '',
          'abono': cells[5] === '+' ? cells[6].trim() : '',
          'importe': cells[6].trim(),
          'saldo': cells[7].trim(),
          'referencia': cells[8].trim(),
          'concepto': cells[9].trim(),
          'bancoParticipante': cells[10].trim(),
          'clabeBeneficiario': cells[11].trim(),
          'nombreBeneficiario': cells[12].trim(),
          'ctaOrdenante': cells[13].trim(),
          'nombre ordenante': cells[14].trim(),
          'codigoDevolucion': cells[15].trim(),
          'causaDevolucion': cells[16].trim(),
          'rfcBeneficiario': cells[17].trim(),
          'rfcOrdenante': cells[18].trim(),
          'claveRastre': cells[19].trim(),
        })
      }
    })

    return this.CargarMovimientosBancariosService.tabla(resultado, obj_CuentaBancaria, session)
  }
}

module.service('CargarMovimientosBancariosCsvSantander', CargarMovimientosBancariosCsvSantanderService)



// WEBPACK FOOTER //
// ./src/finanzas/services/CargarMovimientosBncariosCsvSantander.js